import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { Button } from '../Button/Button.esm.js';

// Helper function to map Link sizes to Button sizes
const mapLinkSizeToButtonSize = (linkSize) => {
    switch (linkSize) {
        case "sm":
            return "sm";
        case "md":
            return "md";
        default:
            return "md";
    }
};
// ButtonLink component (for <button> tag)
const LinkButton = React__default.forwardRef((_a, ref) => {
    var { children, variant, size, buttonVariant } = _a, props = __rest(_a, ["children", "variant", "size", "buttonVariant"]);
    const buttonSize = mapLinkSizeToButtonSize(size);
    return (jsx(Button, Object.assign({ ref: ref, variant: buttonVariant || "unstyled", size: buttonSize }, props, { role: "button", children: children })));
});

export { LinkButton };
